import cross from '~/assets/icons/cross.svg';
import {
	setCategorySelectVisible,
	setCreateCategory,
	setItemSelectVisible,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { AppAdsTypes, appAdsFilterButtons } from '../AppAds/AppAds.model';
import { TextLabel } from '../TextLabel';
import {
	StyledContainer,
	StyledCategories,
	StyledCategory,
	StyledButton,
	StyledCrossButton,
} from './AppAdsCategorySelect.styled';

const AppAdsCategorySelect = () => {
	const dispatch = useLayoutDispatch();
	const createCategory = useLayoutSelector((state) => state.ads.createCategory);

	const handleClose = () => {
		dispatch(setCategorySelectVisible(false));
	};

	return (
		<StyledContainer>
			<TextLabel style={{ fontSize: 14, color: '#ffffff', opacity: 0.5 }}>
				Выберите категорию
			</TextLabel>
			<StyledCategories>
				{Object.values(AppAdsTypes).map((item) => (
					<StyledCategory
						$active={item === createCategory}
						key={item}
						onClick={() => dispatch(setCreateCategory(item))}
					>
						<img src={appAdsFilterButtons[item].icon} />
						<TextLabel>{appAdsFilterButtons[item].name}</TextLabel>
					</StyledCategory>
				))}
			</StyledCategories>
			<StyledButton
				onClick={() => {
					dispatch(setCategorySelectVisible(false));
					dispatch(setItemSelectVisible(true));
				}}
			>
				Продолжить
			</StyledButton>
			<StyledCrossButton onClick={handleClose}>
				<img src={cross} />
			</StyledCrossButton>
		</StyledContainer>
	);
};

export { AppAdsCategorySelect };
